<template lang="html">
    <div class="landing-page">
        <home-hero></home-hero>
        <marketplace></marketplace>
        <explore-cities></explore-cities>
        <top-rated-homes></top-rated-homes>
        <div class="container how-it-works mt-5">
            <h2 class="fw-600  mb-3"> How it works </h2>
            <div class="btn-wrapper d-flex fw-normal mb-3">
                <span @click="hostRoom = true" :class="{ active: hostRoom }" class="text pointer font2"><span> I have room(s) to
                        host</span></span>
                <span @click="hostRoom = false" :class="{ active: !hostRoom }" class="text pointer font2 me-0"><span> I am looking
                        for a room </span></span>
            </div>

            <div class="">
                <div v-show="hostRoom === true" class="position-relative">
                    <img srcset="@/assets/images/host-room.jpg 1322w, @/assets/images/host-room-mobile.jpg 328w"
                        sizes="(min-width: 768px) 1322px, 328px" src="@/assets/images/host-room.jpg" class="w-100" />
                    <div class="position-absolute info">
                        <h3 class="header  text-white fw-600 mb-2"> Host your available <br
                                class="d-xl-none"> rooms <br class="d-none d-xl-block"> on Muster </h3>
                        <p class="font-weight-normal text-white  mb-3 mb-xl-4"> Earn up to 30% more </p>
                        <router-link to="/why-host" class=" ft-12 more-btn border-0  font-weight-normal"> Learn more
                        </router-link>
                    </div>
                </div>

                <div v-show="hostRoom === false" class="position-relative">
                    <img srcset="@/assets/images/rent-room.jpg 1323w, @/assets/images/rent-room-mobile.jpg 328w"
                        sizes="(min-width: 768px) 1323px, 328px" src="@/assets/images/rent-room.jpg" class="w-100">
                    <div class="position-absolute info">
                        <h3 class="header  text-white fw-600 mb-2"> Find your next room </h3>
                        <p class="font-weight-normal  text-white mb-4"> Monthly subscription, furnished rooms <br> Flexible rental
                            contract </p>
                        <router-link to="why-rent" class="more-btn border-0 ft-12"> Learn more </router-link>
                    </div>
                </div>
            </div>
        </div>
        <tailored></tailored>
        <div class="featured m-auto">
            <p class=" text-center">As featured in</p>
            <div class="muster_media px-5 d-flex align-items-center justify-content-between">
                <img src="@/assets/images/BBC.png" alt="Muster on BBC Africa" />
                <img src="@/assets/images/Aljazeera.png" alt="Muster on Aljazeera" />
                <img src="@/assets/images/CNBC.png" alt="Muster on CNBC International" />
                <img src="@/assets/images/Business-day.png" alt="Muster on Business Day" />
                <img src="@/assets/images/Disrupt.png" alt="Muster on Disrupt Africa" />
            </div>
        </div>
        <faq-snippet></faq-snippet>
    </div>
</template>

<style>
    .ft-16 {
        font-size: 16px !important;
    }

    .ft-10 {
        font-size: 10px !important;
    }

    .ft-14 {
        font-size: 14px !important;
    }

    .ft-12 {
        font-size: 12px !important;
    }
    .custom-img {
        width: 150px; 
        height: 150px; 
        object-fit: contain;
    }
    .fw-600 {
        font-weight: 600;
    }

    .featured {
        max-width: 768px;
    }

    .featured p {
        font-size: 16px;
    }

    @media (min-width: 768px) {
        .featured p {
            font-size: 30px;
        }
    }

    .muster_media img {
        max-width: 50px;
        max-height: 40px;
    }

    @media (min-width: 768px) {
        .muster_media img {
            max-width: none;
            max-height: none;
        }
    }

    .font-weight-normal {
        font-weight: 400 !important;
    }

    .how-it-works .info {
        bottom: 30px;
        left: 25px;
        color: #fff;
    }

    @media (min-width: 1200px) {
        .how-it-works .info {
            left: 45px;
            bottom: 50px;
        }
    }

    @media (min-width: 1400px) {
        .how-it-works .info {
            left: 65px;
            bottom: 100px;
        }
    }

    .how-it-works .header {
        line-height: 109.6%;
        font-size: 24px;
        letter-spacing: 0.01em;
    }

    @media (min-width: 1200px) {
        .how-it-works .header {
            line-height: 109.6%;
            line-height: 145%;
            font-size: 28px;
        }
    }

    .how-it-works .header+p {
        font-size: 16px;
    }

    @media (min-width: 1200px) {
        .how-it-works .header+p {
            font-size: 20px;
        }
    }

    .how-it-works .more-btn {
        padding: 8px 16px;
        color: #E81865;
        font-weight: normal;
        display: inline-block;
        background: #FFFFFF;
        border-radius: 8px;
    }

    .how-it-works .more-btn:hover {
        background-color: #efefef;
    }

    @media (min-width: 1200px) {
        .how-it-works .more-btn {
            padding: 12px 24px;
        }
    }

    .how-it-works img {
        height: 323px;
        object-fit: cover;
        border-radius: 8px;
    }

    @media (min-width: 768px) {
        .how-it-works img {
            height: auto;
        }
    }

    .how-it-works .btn-wrapper {
        font-size: 15px;
    }

    .how-it-works .btn-wrapper .active {
        color: #E81865;
    }

    .how-it-works .btn-wrapper .active::after {
        content: "";
        border-bottom: solid #E81865;
        border-radius: 58px 58px 0px 0px;
        padding-bottom: 12px;
        display: block;
        margin: 0 auto;
        width: calc(100% - 14px);
    }

    .how-it-works .btn-wrapper .text {
        margin-right: 16px;
    }

    @media (min-width: 375px) {
        .how-it-works .btn-wrapper .text {
            margin-right: 24px;
        }
    }

    .how-it-works .btn-wrapper .text>span {
        padding: 12px 8px;
    }

    @media (min-width: 375px) {
        .how-it-works .btn-wrapper .text>span {
            padding: 12px 8px;
        }
    }

    @media (min-width: 768px) {
        .how-it-works .btn-wrapper .text>span {
            padding: 12px 8px;
        }
    }

    .how-it-works .btn-wrapper .text:hover>span {
        background: #F5F5F5;
        border-radius: 8px;
    }

    @media (min-width: 360px) {
        .how-it-works .btn-wrapper {
            white-space: nowrap;
        }
    }

    @media (min-width: 768px) {
        .how-it-works .btn-wrapper {
            margin-left: -5px;
            font-size: 16px;
        }
    }
   
</style>

<script>
import ExploreCities from '@/components/home/home-explore-cities.vue';
import HomeHero from '@/components/home/home-hero.vue';
import Marketplace from '@/components/home/home-marketplace.vue';
import Tailored from '@/components/home/home-tailored.vue';
import FaqSnippet from '@/components/home/home-faq.vue';
import TopRatedHomes from '@/components/home/home-top-homes.vue';


export default {
    data: function () {
        return {
            hostRoom: true,
        };
    },

    components: {
        ExploreCities,
        HomeHero,
        Marketplace,
        Tailored,
        FaqSnippet,
        TopRatedHomes
    }
}
</script>